/**
 * Denis Callinan
 * Project Andromeda
 * August 2nd, 2020
 * Classbox.js - Component for the 'education' section
 */

import React from 'react';
import './ClassBox.css'

// Components

export default class ClassBox extends React.Component {
    render() {
        var items;
        if (this.props.comp) {
            items = this.props.comp.map(element => {
                return <li id = {this.props.width > 950 ? "bullet-reg": "bullet-mobile"}>{element}</li>
            });
        }
        
        return(
            <div className = "classBox" id = {this.props.width > 950 ? "class-reg": "class-mobile"}>
                <img src = {require("../../img/" + this.props.image)} id = "school-logo" alt = "UVa Logo"/>
                <h4 align = {this.props.width> 950 ? "left": "center"}>{this.props.name}</h4>
                <p align = {this.props.width > 950 ? "right": "center"}><i>{this.props.location}</i></p> 
                <h4 align = {this.props.width > 950 ? "left": "center"}>{this.props.special}</h4>
                <p align = {this.props.width > 950 ? "right": "center"}><i>{this.props.duration}</i></p>
                <ul id = {this.props.width > 950 ? "courses": "courses-mobile"}>
                    {items}
                </ul>
            </div>
        );
    }
}